import React, { Fragment } from 'react';
import AppHeader from '../../Layout/AppHeader';
import AppSidebar from '../../Layout/AppSidebar';
import AppFooter from '../../Layout/AppFooter';
import ApplicationsList from './Pages/ApplicationsList';

const ApplicationsListWrapper = ({ match }) => (
    <Fragment>
        <AppHeader />
        <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
                <div >
                    <ApplicationsList />
                </div>
                <AppFooter />
            </div>
        </div>
    </Fragment>
);

export default ApplicationsListWrapper;